import { russianPlurals } from "~/utils/russianPlurals";

export default defineI18nConfig(() => ({
  legacy: false,
  pluralRules: {
    ["ru-by"]: russianPlurals,
  },
}));
